import reduxApi from 'redux-api';
import { tokenOptions, adapterJquery, baseApiUrl } from './ApiHelpers';

export default reduxApi({
  me: {
    url: `${baseApiUrl}/v1/publishers/me`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  meUpdate: {
    url: `${baseApiUrl}/v1/publishers/me`,
    virtual: true,
    helpers: {
      post(data) {
        return [{}, {
          data,
          method: 'PUT'
        }];
      }
    }
  },
  billing: {
    url: `${baseApiUrl}/v1/publisher/billing/me`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  billingUpdate: {
    url: `${baseApiUrl}/v1/publisher/billing/me`,
    virtual: true,
    helpers: {
      post(data) {
        return [{}, {
          data,
          method: 'PUT'
        }];
      }
    }
  },
  payments: {
    url: `${baseApiUrl}/v1/publisher/payments`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  cnames: {
    url: `${baseApiUrl}/v1/publisher/c_names`,
    options: {
      method: 'GET'
    }
  },
  cnameCreate: {
    url: `${baseApiUrl}/v1/publisher/c_names`,
    virtual: true,
    helpers: {
      post(data) {
        return [{}, {
          data: { 
            c_name: { 
              ...data.cname 
            } 
          },
          method: 'POST'
        }];
      }
    }
  },
  cnameDelete: {
    url: `${baseApiUrl}/v1/publisher/c_names/:id`,
    virtual: true,
    helpers: {
      post(id) {
        return [{ id }, {
           method: 'DELETE'
        }];
      }
    }
  },
  websites: {
    url: `${baseApiUrl}/v1/publisher/websites`,
    options: {
      method: 'GET'
    }
  },
  websiteCreate: {
    url: `${baseApiUrl}/v1/publisher/websites`,
    virtual: true,
    helpers: {
      post(data) {
        return [{}, {
          data: { 
            website: {
              ...data.website
            } 
          },
          method: 'POST'
        }];
      }
    }
  },
  websiteUpdate: {
    url: `${baseApiUrl}/v1/publisher/websites/:id`,
    virtual: true,
    helpers: {
      post(id, data) {
        return [{ id }, {
          data: { 
            website: { 
              ...data.website 
            } 
          },
          method: 'PUT'
        }];
      }
    }
  },
  websiteCnameUpdate: {
    url: `${baseApiUrl}/v1/publisher/websites/:id`,
    virtual: true,
    helpers: {
      post(id, data) {
        return [{ id }, {
          data: { 
            website: { 
              ...data.website 
            } 
          },
          method: 'PUT'
        }];
      }
    }
  },
  websiteDelete: {
    url: `${baseApiUrl}/v1/publisher/websites/:id`,
    virtual: true,
    helpers: {
      post(id) {
        return [{ id }, {
           method: 'DELETE'
        }];
      }
    }
  },
  websiteSubIds: {
    url: `${baseApiUrl}/v1/publisher/websites/:id/sub_ids`,
    helpers: {
      get(id) {
        return [{ id }, {
           method: 'GET'
        }];
      }
    }
  },
  reports: {
    url: `${baseApiUrl}/v1/publisher/reports`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  allReports: {
    url: `${baseApiUrl}/v1/publisher/reports/combined`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  pixel: {
    url: `${baseApiUrl}/v1/publisher/pixels`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  templates: {
    url: `${baseApiUrl}/v1/publisher/templates`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  templateDelete: {
    url: `${baseApiUrl}/v1/publisher/templates/:id`,
    virtual: true,
    helpers: {
      post(id) {
        return [{ id }, {
          method: 'DELETE'
        }];
      }
    }
  },
  templateCreate: {
    url: `${baseApiUrl}/v1/publisher/templates`,
    virtual: true,
    helpers: {
      post(data) {
        return [{}, {
          data,
          method: 'POST'
        }];
      }
    }
  },
  templateUpdate: {
    url: `${baseApiUrl}/v1/publisher/templates/:id`,
    virtual: true,
    helpers: {
      post(id, data) {
        return [{ id }, {
          data,
          method: 'PUT'
        }];
      }
    }
  },
  templateUpdateDefault: {
    url: `${baseApiUrl}/v1/publisher/templates/:id/set_as_default`,
    virtual: true,
    helpers: {
      post(id, data) {
        return [{ id }, {
          data,
          method: 'PUT'
        }];
      }
    }
  },
  emailTemplate: {
    url: `${baseApiUrl}/v1/publisher/email_templates/`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  emailTemplateUpdate: {
    url: `${baseApiUrl}/v1/publisher/email_templates/:id`,
    virtual: true,
    helpers: {
      post(id, data) {
        return [{ id }, {
          data,
          method: 'PUT'
        }];
      }
    }
  },
  liveAlertTest: {
    url: `${baseApiUrl}/v1/publisher/email_templates/:id/live_email_test`,
    virtual: true,
    helpers: {
      post(id, data) {
        return [{ id }, {
          data,
          method: 'PUT'
        }];
      }
    }
  }
}).use('options', tokenOptions).use('fetch', adapterJquery);
